// import VueCookies from 'vue-cookies'
import { Auth } from 'aws-amplify'
import axios from 'axios'
import 'whatwg-fetch'
import config from '../config'

// これでクッキー保存。
// VueCookies.set('auth_token');

export default {
  namespaced: true,
  state: {
    status: '',
    loggedIn: false,
    user: null,
    userdata: null,
    userName: '',
    changePasswordUser: {},
    isMyoridge: !!location.hostname.match('myoridge'),
    // access_token: VueCookies.get('access_token') || null,// token || null
    // id_token: VueCookies.get('id_token') || null,// token || null
    // refresh_token: VueCookies.get('refresh_token') || null,// token || null
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    error(state) {
      state.status = 'error'
    },
    login(state, res) {
      state.status = 'success'
      state.user = res
      state.loggedIn = true
    },
    changePasswordUser(state, res) {
      state.changePasswordUser = res
    },
    logout(state) {
      state.user = null
      state.loggedIn = false
    },
    userdata(state, data) {
      state.userdata = data
    },
    userName(state, name) {
      state.userName = name
    },
  },
  actions: {
    user(context) {
      const loginUrl = (process.env.NODE_ENV !== 'development' ? '/base' : '') + '/auth/login.html?back=' + encodeURIComponent(location.pathname + location.search + location.hash)
      return new Promise((resolve) => {
        Auth.currentAuthenticatedUser({
          bypassCache: false,
        }).then(user => {
          context.commit('login', user.signInUserSession)
          context.commit('changePasswordUser', user)
          // ユーザー名を取得
          axios.get(`${config.CommonApiUrl}/user`, {
            headers: {
              'Authorization': user.signInUserSession.idToken.jwtToken,
            },
          }).then(res => {
            context.commit('userdata', res.data)
            context.commit('userName', res.data.name)
            resolve(user)
          }).catch(err => {
            console.log(err)
            window.location.href = loginUrl
          })
        }).catch(err => {
          console.log(err)
          window.location.href = loginUrl
        })
      })
    },
    login(context, credentials) {
      const user_id = `${credentials.login_id}/${credentials.company_id}`
      return new Promise((resolve, reject) => {
        Auth.signIn(user_id, credentials.password).then(user => {
          context.commit('login', user.signInUserSession)
          resolve()
        }).catch(err => {
          context.commit('error', err)
          reject()
        })
      })
    },
    logout({state}) {
      if (window?.dataLayer) {
        try {
          const cognitoUId = state.userdata.cognitoUId.split('/')
          window.dataLayer.push({
            event: 'logout',
            page_url: window.location.href,
            page_title: document.title,
            login_user_id: cognitoUId[0],
            login_company_id: cognitoUId[1],
            member_id: state.userdata.id,
          })
          localStorage?.removeItem('__monorevo.login.info')
        } catch (e) {
          // eslint-disable-next-line
          console.error(e)
        }
      }
      const loginUrl = (process.env.NODE_ENV !== 'development' ? '/base' : '') + '/auth/login.html'
      return new Promise((resolve, reject) => {
        Auth.signOut()
          .then(() => {
            window.location.href = loginUrl
            resolve()
          })
          .catch(() => {
            window.location.href = loginUrl
            reject()
          })
      })
    },
    changePassword(context, { newPassword, oldPassword }) {
      return new Promise((resolve, reject) => {
        if (context.state.loggedIn && context.state.changePasswordUser) {
          Auth.changePassword(context.state.changePasswordUser, oldPassword, newPassword).then(message => {
            // console.log('CHANGED PASSWORD')
            // console.log(message)
            resolve(message)
          }).catch(err => {
            reject(err)
          })
        } else {
          reject()
        }
      })
    },
    // セッションを取得するのに利用する
    refresh(context) {
      return new Promise((resolve) => {
        Auth.currentSession().then(data => {
          context.commit('login', data)
          resolve(data)
        })
      })
    },
    forgetPassword(context, credentials) {
      const user_id = `${credentials.login_id}/${credentials.company_id}`
      return new Promise((resolve, reject) => {
        Auth.forgotPassword(user_id).then(data => {
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    forgotPasswordSubmit(context, credentials) {
      const user_id = `${credentials.login_id}/${credentials.company_id}`
      return new Promise((resolve, reject) => {
        Auth.forgotPasswordSubmit(user_id, credentials.code, credentials.password).then(data => {
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    },
  },
  getters: {
    user: state => {
      return state.user
    },
    userdata: state => {
      return state.userdata
    },
    username: state => {
      if (state.user) {
        return state.userName
      } else {
        return ''
      }
    },
    loggedIn: state => {
      return state.loggedIn
    },
    authorization: state => {
      if (state.user && state.user.idToken && state.user.idToken.jwtToken) return state.user.idToken.jwtToken
      return null
    },
    isMyoridge: state => {
      return state.isMyoridge
    },
  },
}
